import { Component, Input } from '@angular/core';
import { MemoizedSelector, Store } from '@ngrx/store';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { actions, FeatureKeyType, ListConfigurationInterface, reducers, selectors } from '@twaice-fe/frontend/shared/store';

const { healthSelectors } = selectors;
const { healthAction } = actions;
const {
  healthReducer: { HEALTH_STRINGS_DISTRIBUTION_FEATURE_KEY },
} = reducers;

@Component({
  template: '',
  standalone: false,
})
export abstract class BaseStoreComponent {
  @Input() uniqueStateName: FeatureKeyType;

  constructor(protected store: Store) {}

  /**
   * Dynamically return selector of the unique list name
   * MemoisedSelector have the any type here because it can have multiple types which are not possible to state at this stage
   */
  getSelector(): MemoizedSelector<any, any, any> {
    switch (this.uniqueStateName) {
      case HEALTH_STRINGS_DISTRIBUTION_FEATURE_KEY:
        return healthSelectors.getStringsDistribution;
    }
  }

  getConfigActions(config: ListConfigurationInterface, isLoading?: boolean) {
    switch (this.uniqueStateName) {
      case HEALTH_STRINGS_DISTRIBUTION_FEATURE_KEY:
        return healthAction.updateStringsDistributionListConfiguration({ config, isLoading });
      default:
        console.warn(this.uniqueStateName);
        break;
    }
  }

  getSortActions(order: string) {
    switch (this.uniqueStateName) {
      case HEALTH_STRINGS_DISTRIBUTION_FEATURE_KEY:
        return healthAction.sortStringsDistribution({ order });
      default:
        break;
    }
  }

  getTableConfigActions(config: ListConfigurationInterface) {
    switch (this.uniqueStateName) {
      case HEALTH_STRINGS_DISTRIBUTION_FEATURE_KEY:
        return healthAction.stringsDistributionColumnPicker({ columns: config.columns });
      default:
        break;
    }
  }
}
